






































































































































































































































































































































































import { Component, Vue, Watch } from 'vue-property-decorator';
import PageTitle from '@/components/common/PageTitle.vue';
import CompSelectBox from '@/components/common/CompSelectBox.vue';
import CompRadioButton from '@/components/common/CompRadioButton.vue';
import DeliveryTab from '@/components/delivery/DeliveryTab.vue';
import ReturnDeliveryAmtGuide from '@/components/delivery/ReturnDeliveryAmtGuide.vue';
import DeliveryGroupAddTemplateForm from '@/components/delivery/DeliveryGroupAddTemplateForm.vue';
import DeliveryGroupModifyTemplateForm from '@/components/delivery/DeliveryGroupModifyTemplateForm.vue';
import LayerPopup from '@/components/LayerPopup.vue';
import { ncpPopup } from '@/utils/ncp';
import {
  AddTemplate,
  Areafee,
  DeleteDeliveryTemplateGroupsByGroupNoRequest,
  DeliveryCompany,
  GetDeliveryTemplate,
  GetDeliveryTemplateGroup,
  ModifyTemplate,
  PostDeliveryTemplateGroup,
  PostDeliveryTemplateGroupsRequest,
  postDeliveryTemplateGroupsValidation,
  PutDeliveryTemplateGroupsByGroupNoDisplayOrderRequest,
  PutDeliveryTemplateGroupsByGroupNoRequest,
  putDeliveryTemplateGroupsByGroupNoValidation,
  Warehouse,
  EnumsType,
  CurrencyCode,
} from 'supporter';
import { DeliveryTemplateGroup } from '@/types/delivery';
import deliveryTypes from '@/const/words/deliveryTypes';
import currencyCodeOptions from '@/const/words/currencyCodeOptions';
import deliveryConditionTypes from '@/const/words/deliveryConditionTypes';
import { namespace } from 'vuex-class';
import { GlobalMall } from '@/types/mall';
import {Admin} from '@/types';

const adminModule = namespace('admin');
const mallModule = namespace('mall');

@Component({
  components: {
    PageTitle,
    CompSelectBox,
    CompRadioButton,
    DeliveryTab,
    DeliveryGroupAddTemplateForm,
    DeliveryGroupModifyTemplateForm,
    LayerPopup,
    ReturnDeliveryAmtGuide,
  },
})
export default class DeliveryConditionGroupList extends Vue {
  @adminModule.Getter('admin') private admin!: Admin;

  private deliveryTypes = deliveryTypes;
  private currencyCodeOptions = currencyCodeOptions;
  private deliveryConditionTypes = deliveryConditionTypes;
  private deliveryCompanyTypes: DeliveryCompany[] = [];
  private warehouses: Warehouse[] = [];
  private formEdited: boolean = false;
  // 반품/교환 배송비 가이드 layer
  private dispalyreturnDeliveryAmtGuide = false;
  // 템플릿 추가 form display flag
  private displayAddTemplate: boolean = false;
  // 템플릿 수정 form display flag
  private displayModifyTemplate: boolean = false;
  // db에서 조회된 그룹s
  private fetchedDeliveryGroups: GetDeliveryTemplateGroup[] = [];
  // 추가란 그룹
  private addedDeliveryGroup: PostDeliveryTemplateGroup | null = null;
  // 선택된 그룹
  private selectedDeliveryGroup: DeliveryTemplateGroup | null = null;

  // 추가된 templates
  private addedTemplates: AddTemplate[] = [];
  private modifyTemplates: ModifyTemplate[] = [];
  private selectedModifyTemplate: AddTemplate | GetDeliveryTemplate | null = null;
  private deletedTemplates: number[] = [];

  private areaFees: Areafee[] = [];
  private prepaidRadioOptions = {
    name: 'prepaid',
    data: [
      {
        id: 'prepaid_true',
        value: true,
        dispaly: 'DELIVERY_GROUP_TEMPLATE_PREPAID_TRUE',
      },
      {
        id: 'prepaid_false',
        value: false,
        dispaly: 'DELIVERY_GROUP_TEMPLATE_PREPAID_FALSE',
      },
    ],
  };
  private areaFeeFlagRadioOptions = {
    name: 'areaFeeFlag',
    data: [
      {
        id: 'areaFeeFlag_N',
        value: 'N',
        dispaly: 'DELIVERY_GROUP_TEMPLATE_NOT_USE',
      },
      {
        id: 'areaFeeFlag_Y',
        value: 'Y',
        dispaly: 'DELIVERY_GROUP_TEMPLATE_USE',
      },
    ],
  };
  get displayTemplates() {
    return [...(this.selectedDeliveryGroup as DeliveryTemplateGroup).templates, ...this.addedTemplates];
  }

  // 기본 템플릿 존재 여부 확인 - 지금은 딱히 쓸 일이 없어서 주석처리. 통합할 때 쓸 수 있음.
  // private async getHasDefaultTemplate() {
  //   // currencyCd: KRW | JPY | USD
  //   const { data } = await this.$api.axios.get('/delivery/templates/has-default?currencyCd=' + this.currencyCode);
  //   return data.hasDefaultTemplate;
  // }

  get hasDefaultTemplateInCurrentGroup() {
    // 전체 그룹에서 현재 그룹의 통화코드와 동일한 템플릿 중에 기본 템플릿이 있는지 확인
    const hasDefaultTemplateInAllGroups = this.fetchedDeliveryGroups.some(group => 
      group.currencyCode === this.currencyCode && group.templates.some(template => template.default)
    );

    // 새로 추가된 템플릿들 중에 기본 템플릿이 있는지 확인
    const hasDefaultInAddedTemplates = this.addedTemplates.some(template => template.default);
    const hasDefaultInModifyTemplates = this.modifyTemplates.some(template => template.default);
    
    return hasDefaultTemplateInAllGroups || hasDefaultInAddedTemplates || hasDefaultInModifyTemplates;
  }

  private useAreaFee = 'N';
  private areaFeeNo: number = -1;

  private undeliverableCountriesPopup = false;
  private undeliverableCountriesPopupRequestData = {
    id: 'maximumOrderAmountPopup',
    hasConfirmBtn: false,
    hasCloseBtn: false,
    title: this.$t('DELIVERY_GROUP_TEMPLATE_UNDELIVERABLE_COUNTRY'),
    width: 570,
  };

  private countries: EnumsType[] = [];
  private undeliverableCountries: string[] = [];
  private currencyCode: CurrencyCode = 'KRW';
  private getCountries() {
    this.$api.getShippingsEnums().then(({ data: { countryCd } }) => {
      this.countries = countryCd;
    });
  }
  private getCountryLabel(country: string) {
    return this.countries.find(item => item.name === country)?.label ?? '';
  }
  private removeUndeliverableCountry(country: string) {
    this.undeliverableCountries = this.undeliverableCountries.filter(item => item !== country);
  }

  @Watch('areaFees')
  onAreaFeesChanged(newVal: Areafee[]) {
    const selectedDeliveryGroup: any = this.selectedDeliveryGroup;

    if (this.useAreaFee === 'Y' && this.areaFeeNo > 0) { 
      selectedDeliveryGroup.areaFee = newVal.find(item => item.areaFeeNo === this.areaFeeNo);
    }

    this.selectedDeliveryGroup = selectedDeliveryGroup;
  }

  @Watch('useAreaFee')
  onAreaFeeFlagChanged(newVal: string) {
    const selectedDeliveryGroup: any = this.selectedDeliveryGroup;
    if (this.addedDeliveryGroup) {
      selectedDeliveryGroup.usesAreaFee = newVal === 'Y';
    }
    this.selectedDeliveryGroup = selectedDeliveryGroup;
  }
  @Watch('areaFeeNo')
  onAreaFeeNoChanged(newVal: number) {
    const selectedDeliveryGroup: any = this.selectedDeliveryGroup;
    if (this.addedDeliveryGroup) {
      selectedDeliveryGroup.areaFeeNo = newVal;
    } else {
      selectedDeliveryGroup.areaFee = this.areaFees.find(item => item.areaFeeNo === newVal);
    }
    this.selectedDeliveryGroup = selectedDeliveryGroup;
  }

  fetchDeliveryTemplateGroups(callback: Function) {
    this.$api.getDeliveryTemplateGroups().then(ret => callback(ret));
  }
  @Watch('currencyCode')
  onCurrencyCodeChanged(currencyCode?: CurrencyCode) {
    const selectedCurrencyCode = currencyCode ?? this.currencyCode;
    // this.getHasDefaultTemplate();

    this.$api
      .getAreafees({
        params: {
          page: 1,
          size: 1500,
          currencyCode: selectedCurrencyCode,
        },
      })
      .then(ret => {
        if (ret && ret.data) {
          this.areaFees = ret.data.contents;
        }
      });
  }

  @mallModule.Getter('mallsGlobal')
  private readonly malls: GlobalMall[];

  private get currencyCodeDisabled() {
    return !!this.selectedDeliveryGroup?.templateGroupNo || !this.malls?.some(({globalMallType})=> globalMallType === 'SEPARATED_GLOBAL_MAIN');
  }

  private created() {
    this.fetchDeliveryTemplateGroups((ret): void => {
      if (ret && ret.data) {
        this.fetchedDeliveryGroups = ret.data;
        this.setDeliveryGroup(ret.data[0]);
      }
    });
    const params = {
      page: 1,
      size: 1500,
    };

    this.onCurrencyCodeChanged();
    this.$api.getDeliveryCompanies({ params: { countryCd: 'KR' } }).then(ret => {
      if (ret && ret.data) {
        this.deliveryCompanyTypes = ret.data;
      }
    });
    this.$api.getWarehouses({ params }).then(ret => {
      if (ret && ret.data) {
        this.warehouses = ret.data.contents;
      }
    });

    this.getCountries();
  }
  // 그룹 선택시
  private setDeliveryGroup(deliveryGroup: any, isAdded?: boolean): void {
    if (this.formEdited) {
      if (confirm(this.$t('DELIVERY_GROUP_TEMPLATE_CONFIRM').toString())) {
        this.fetchDeliveryTemplateGroups(ret => {
          if (ret && ret.data) {
            this.fetchedDeliveryGroups = ret.data;
          }
        });
        if (!isAdded) {
          this.addedDeliveryGroup = null;
        }

        this.formEdited = false;
        this.addedTemplates = [];
        this.modifyTemplates = [];
        this.selectedDeliveryGroup = deliveryGroup;
        this.currencyCode = deliveryGroup?.currencyCode ?? 'KRW';
      }
    } else {
      this.selectedDeliveryGroup = deliveryGroup;
      this.currencyCode = deliveryGroup?.currencyCode ?? 'KRW';
    }

    this.undeliverableCountries = this.selectedDeliveryGroup.undeliverableCountries ?? [];

    if (deliveryGroup && deliveryGroup.hasOwnProperty('usesAreaFee')) {
      this.areaFeeNo = deliveryGroup.areaFeeNo;
      this.useAreaFee = deliveryGroup.usesAreaFee ? 'Y' : 'N';
    } else {
      this.areaFeeNo =
        deliveryGroup && deliveryGroup.areaFee && (deliveryGroup.areaFee.areaFeeNo || -1);
      this.useAreaFee = deliveryGroup && deliveryGroup.areaFee ? 'Y' : 'N';
    }
  }
  // 배송방법 유형 name 획득 방법
  private getDeliveryType(value: string) {
    const findeDeliveryType = this.deliveryTypes.find((item: any) => item.value === value);
    if (findeDeliveryType) {
      return findeDeliveryType.name;
    }
  }
  // 배송비유형 name 획득 방법
  private getDeliveryConditionType(value: string) {
    const findedeliveryConditionType = this.deliveryConditionTypes.find((item: any) => item.value === value);
    if (findedeliveryConditionType) {
      return findedeliveryConditionType.name;
    }
  }
  // 그룹추가
  private addGroup() {
    if (!this.addedDeliveryGroup) {
      const text = this.$t('DELIVERY_GROUP_TEMPLATE_NEW_GROUP');
      const deliveryGroup: PostDeliveryTemplateGroup = {
        groupDeliveryAmtType: 'MAXIMUM_SELECTED',
        templates: [],
        name: text.toString(),
        usesAreaFee: false,
        prepaid: true,
      };
      this.addedDeliveryGroup = deliveryGroup;
    }
    this.setDeliveryGroup(this.addedDeliveryGroup, true);

    this.formEdited = true;
  }
  // 그룹삭제
  private deleteGroup() {
    const selectedGroup = this.selectedDeliveryGroup as GetDeliveryTemplateGroup;
    if (confirm(this.$t('DELIVERY_GROUP_TEMPLATE_DELETE3').toString())) {
      if (selectedGroup.hasOwnProperty('templateGroupNo')) {
        const deleteRequest: DeleteDeliveryTemplateGroupsByGroupNoRequest = {
          params: {
            templateGroupNo: selectedGroup.templateGroupNo,
          },
        };
        this.$api.deleteDeliveryTemplateGroupsByGroupNo(deleteRequest).then(() => {
          const { templateGroupNo } = selectedGroup;
          const findedIndex = this.fetchedDeliveryGroups.findIndex((item: GetDeliveryTemplateGroup) => {
            return item.templateGroupNo === templateGroupNo;
          });
          this.fetchedDeliveryGroups.splice(findedIndex, 1);
          this.setDeliveryGroup(this.fetchedDeliveryGroups[0]);
        });
      } else {
        this.addedDeliveryGroup = null;
        this.formEdited = false;
        this.setDeliveryGroup(this.fetchedDeliveryGroups[0]);
      }
    }
  }

  // 변경사항 저장
  private groupSave() {
    const { templateGroupNo } = this.selectedDeliveryGroup as GetDeliveryTemplateGroup;
    if (templateGroupNo) {
      const selectedDeliveryGroup = this.selectedDeliveryGroup as GetDeliveryTemplateGroup;
      const areaFee = selectedDeliveryGroup.areaFee;
      const putRequest: PutDeliveryTemplateGroupsByGroupNoRequest = {
        params: { templateGroupNo },
        data: {
          areaFeeNo: areaFee ? areaFee.areaFeeNo : undefined,
          groupDeliveryAmtType: selectedDeliveryGroup.groupDeliveryAmtType,
          name: selectedDeliveryGroup.name,
          usesAreaFee: this.useAreaFee === 'Y',
          prepaid: selectedDeliveryGroup.prepaid,
          modifyTemplates: this.modifyTemplates,
          deleteTemplateNos: this.deletedTemplates,
          addTemplates: this.addedTemplates,
          undeliverableCountries: this.undeliverableCountries,
          currencyCode: this.currencyCode,
        },
      };
      const validationResult = putDeliveryTemplateGroupsByGroupNoValidation(putRequest);
      if (validationResult.length) {
        alert(this.$t(`DELIVERY_GROUP_TEMPLATE_${validationResult[0].message}`));
      } else if (this.displayTemplates.length === 0) {
        alert(this.$t('DELIVERY_GROUP_TEMPLATE_ALERT2'));
      } else {
        this.$api
          .putDeliveryTemplateGroupsByGroupNo(putRequest)
          .then(this.fetchAfterInit)
          .catch(() => {
            selectedDeliveryGroup.templates = [];
          });
      }
    } else {
      const selectedDeliveryGroup = this.selectedDeliveryGroup as PostDeliveryTemplateGroup;
      if (this.addedTemplates.length) {
        this.addedTemplates.forEach((item: AddTemplate) => {
          selectedDeliveryGroup.templates.push({
            default: item.default!,
            deliveryFee: item.deliveryFee,
            name: item.name!,
            deliveryType: item.deliveryType!,
            returnWarehouseNo: item.returnWarehouseNo!,
            deliveryCompanyType: item.deliveryCompanyType!,
            releaseWarehouseNo: item.releaseWarehouseNo!,
          });
        });
      }
      const postRequest: PostDeliveryTemplateGroupsRequest = {
        data: {
          ...selectedDeliveryGroup,
          undeliverableCountries: this.undeliverableCountries,
          currencyCode: this.currencyCode,
        },
      };
      const validationResult = postDeliveryTemplateGroupsValidation(postRequest);
      if (validationResult.length) {
        alert(this.$t(`DELIVERY_GROUP_TEMPLATE_${validationResult[0].message}`));
      } else if (this.addedTemplates.length === 0) {
        alert(this.$t('DELIVERY_GROUP_TEMPLATE_ALERT2'));
      } else {
        this.$api
          .postDeliveryTemplateGroups(postRequest)
          .then(this.fetchAfterInit)
          .catch(() => {
            selectedDeliveryGroup.templates = [];
          });
      }
    }
  }

  // 기본 템플릿이 변경될 때 다른 템플릿들의 기본 설정을 해제
  private onDefaultTemplateChanged(changedTemplate: any) {
    // 기존 템플릿들 중 기본 템플릿 찾아서 해제
    const existingDefaultTemplate = (this.selectedDeliveryGroup!.templates as GetDeliveryTemplate[])?.find(t => t !== changedTemplate && t.default);
    if (existingDefaultTemplate) {
      existingDefaultTemplate.default = false;
    }
    
    // 새로 추가된 템플릿들 중 기본 템플릿 찾아서 해제
    const addedDefaultTemplate = (this.addedTemplates as any[]).find(t => t !== changedTemplate && t.default);
    if (addedDefaultTemplate) {
      addedDefaultTemplate.default = false;
    }
  }

  // add template
  private addTemplate(template: AddTemplate) {
    this.addedTemplates.push(template);
  }
  // 변경사항 저장후 init
  private fetchAfterInit() {
    const addedDeliveryGroup = this.addedDeliveryGroup;
    this.formEdited = false;
    this.addedTemplates = [];
    this.modifyTemplates = [];
    this.deletedTemplates = [];
    this.addedDeliveryGroup = null;
    this.fetchDeliveryTemplateGroups(ret => {
      if (ret && ret.data) {
        this.fetchedDeliveryGroups = ret.data;
        if (addedDeliveryGroup) {
          this.setDeliveryGroup(this.fetchedDeliveryGroups[this.fetchedDeliveryGroups.length - 1]);
        } else {
          const findGroup = this.fetchedDeliveryGroups.find(item => {
            return item.templateGroupNo === (this.selectedDeliveryGroup as GetDeliveryTemplateGroup).templateGroupNo;
          });
          this.selectedDeliveryGroup = findGroup as GetDeliveryTemplateGroup;
        }
        alert(this.$t('DELIVERY_GROUP_TEMPLATE_SAVED'));
      }
    });
  }
  // 노출 순서 조정
  private displayChange(direction: string) {
    const selectedDeliveryGroup = this.selectedDeliveryGroup as GetDeliveryTemplateGroup;
    if (selectedDeliveryGroup.hasOwnProperty('templateGroupNo') && !this.formEdited) {
      const putRequest: PutDeliveryTemplateGroupsByGroupNoDisplayOrderRequest = {
        params: {
          templateGroupNo: selectedDeliveryGroup.templateGroupNo,
          direction: direction,
        },
      };
      this.$api.putDeliveryTemplateGroupsByGroupNoDisplayOrder(putRequest).then(() => {
        this.fetchDeliveryTemplateGroups((ret): void => {
          if (ret && ret.data) {
            this.fetchedDeliveryGroups = ret.data;
          }
        });
      });
    } else {
      alert(this.$t('DELIVERY_GROUP_TEMPLATE_CONFIRM2'));
    }
  }

  // template에 적용된 상품 보기
  private showDetailTemplate(template: AddTemplate | GetDeliveryTemplate) {
    if (template.hasOwnProperty('templateNo')) {
      const { templateNo } = template as GetDeliveryTemplate;
      ncpPopup(`/deliveryCondition/detailPopup?deliveryTemplateNo=${templateNo}`, '배송비조건템플릿 상세', 1277, 773);
    } else {
      alert(this.$t('DELIVERY_GROUP_TEMPLATE_SHOW_DETAIL_TEMPLATE_MESSAGE'));
    }
  }
  private deleteTemplate(template: AddTemplate | GetDeliveryTemplate) {
    if (confirm(this.$t('DELIVERY_GROUP_TEMPLATE_DELETE3') as string)) {
      if (template.default) {
        alert(this.$t('DELIVERY_GROUP_TEMPLATE_ALERT3'));
      } else {
        if (template.hasOwnProperty('templateNo')) {
          const { templateNo } = template as GetDeliveryTemplate;
          this.$api.getDeliveryTemplateCheckUsing({ params: { templateNo } }).then(ret => {
            if (ret && ret.data) {
              const tempalteUsing = ret.data.using;
              if (tempalteUsing) {
                alert(this.$t('DELIVERY_GROUP_TEMPLATE_ALERT4'));
              } else {
                const findIndex = (this.selectedDeliveryGroup as GetDeliveryTemplateGroup).templates.findIndex(
                  (item: GetDeliveryTemplate) => {
                    return item.templateNo === templateNo;
                  },
                );
                (this.selectedDeliveryGroup as GetDeliveryTemplateGroup).templates.splice(findIndex, 1);
                this.deletedTemplates.push((template as GetDeliveryTemplate).templateNo);
              }
            }
          });
        } else {
          const findIndex = this.addedTemplates.findIndex((item: AddTemplate) => {
            return item === template;
          });
          this.addedTemplates.splice(findIndex, 1);
        }
      }
    }
  }
  private displayModifyTemplateForm(template: AddTemplate | GetDeliveryTemplate) {
    this.displayModifyTemplate = true;
    this.selectedModifyTemplate = template;
  }
  private getWarehouseName(warehouseNo: number) {
    const warehouse = this.warehouses.find((item: Warehouse) => {
      return item.warehouseNo === warehouseNo;
    });
    return warehouse!.name;
  }
  private modifyTemplate(template: AddTemplate | GetDeliveryTemplate) {
    if (template.hasOwnProperty('templateNo')) {
      const getDeliveryTemplate = template as GetDeliveryTemplate;
      const modifyTemplate: ModifyTemplate = {
        templateNo: getDeliveryTemplate.templateNo,
        default: getDeliveryTemplate.default,
        deliveryFee: getDeliveryTemplate.deliveryFee,
        name: getDeliveryTemplate.name,
        deliveryType: getDeliveryTemplate.deliveryType,
        returnWarehouseNo: getDeliveryTemplate.returnWarehouse.warehouseNo,
        deliveryCompanyType: getDeliveryTemplate.deliveryCompanyType,
        releaseWarehouseNo: getDeliveryTemplate.releaseWarehouse.warehouseNo,
      };
      
      // 기본 템플릿이 변경되는 경우, 다른 수정된 템플릿들의 기본 설정을 해제
      if (getDeliveryTemplate.default) {
        const existingDefaultTemplate = this.modifyTemplates.find(t => t.templateNo !== getDeliveryTemplate.templateNo && t.default);
        if (existingDefaultTemplate) {
          existingDefaultTemplate.default = false;
        }
      }
      
      // 기존에 동일한 templateNo가 있는지 확인
      const existingIndex = this.modifyTemplates.findIndex(t => t.templateNo === getDeliveryTemplate.templateNo);
      if (existingIndex !== -1) {
        // 기존 항목을 업데이트
        this.modifyTemplates[existingIndex] = modifyTemplate;
      } else {
        // 새로 추가
        this.modifyTemplates.push(modifyTemplate);
      }
    }
  }
  private addAreaFee() {
    ncpPopup(
      '/deliveryAreaFee/modifyForm',
      this.$t('DELIVERY_GROUP_TEMPLATE_ADDITIONAL_SHIPPING_COST').toString(),
      1024,
      500,
    );
  }
}
